import CryptoJS from 'crypto-js';
import { APP_CONSTANTS } from '../constants';


/**
 * TODO: upgrade the crypto-js package. Currently we have to run below before any script
 * export NODE_OPTIONS=--openssl-legacy-provider. Refer package.json 
 * I think error is due to crypto - Error: error:0308010C:digital envelope routines::unsupported
 */
class SessionStorageService {
  set(key, value) {
    try {
      if (key === APP_CONSTANTS) {
        const Utf16LE = CryptoJS.enc.Utf16LE.parse(JSON.stringify(value));
        const string = CryptoJS.enc.Utf16.stringify(Utf16LE);

        sessionStorage.setItem(key, string);
      } else {
        sessionStorage.setItem(key, value);
      }
    } catch (e) {
      console.log('ERROR in SessionStorageService.js. set(key, value). Error - ', e);
      throw e;
    }
  }

  get(key) {
    const value = sessionStorage.getItem(key);
    try {
      if (value && key === APP_CONSTANTS) {
        const Utf16 = CryptoJS.enc.Utf16.parse(value);

        return JSON.parse(CryptoJS.enc.Utf16LE.stringify(Utf16));
      }
    } catch (e) {
      console.log('ERROR in SessionStorageService.js. get(key) Error - ', e);
      throw e;
    }

    return value;
  }

  remove(key) {
    sessionStorage.removeItem(key);
  }
}

export default new SessionStorageService();
